"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupPOD_STATUS_OTHER_CONDITION = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupPOD_STATUS_OTHER_CONDITION(builder) {
  builder.validator(validator_id_1.ValidatorID.POD_STATUS_OTHER_CONDITION).category(categories_1.ValidatorCategory.Compute).subCategory(categories_1.ValidatorSubCategory.Status).title('Stage 5. Pod custom readiness gate failure').description("Kubernetes allows the implementation of custom readiness checks\nbefore the Pod is permitted to serve traffic.\nThis is very important when implementing operator patterns for stateful services.\n\nThis validator detects if the Pod custom readiness probes are failing.\n").affected('Pod').example("\nkind: Pod\n...\nspec:\n  readinessGates:\n    - conditionType: \"www.example.com/feature-1\"\nstatus:\n  conditions:\n    - type: \"www.example.com/feature-1\"\n      status: \"False\"\n      lastProbeTime: null\n      lastTransitionTime: 2022-01-01T00:00:00Z \n").resolution('Check readiness gates and conditions').externalLink('https://kubernetes.io/docs/concepts/workloads/pods/pod-lifecycle/#pod-readiness-gate');
}

exports.setupPOD_STATUS_OTHER_CONDITION = setupPOD_STATUS_OTHER_CONDITION;